class LogService {
    constructor() {
        this.isEnabled = false;  
    }

    enable() {
        this.isEnabled = true;
    }

    disable() {
        this.isEnabled = false;
    }

    log(...args) {
        if (this.isEnabled) {
            console.log("[LOG]", ...args);
        }
    }

    error(...args) {
        if (this.isEnabled) {
            console.error("[ERROR]", ...args);
        }
    }

    warn(...args) {
        if (this.isEnabled) {
            console.warn("[WARN]", ...args);
        }
    }

    info(...args) {
        if (this.isEnabled) {
            console.info("[INFO]", ...args);
        }
    }
}

// Create a singleton instance
const logService = new LogService();

export default logService;
